import { Image } from '@chakra-ui/react';
import React from 'react';
import footerLogo from '@/assets/fiestabet/images/footer/logoMobile.png';

export default function index() {
  return <Image src={footerLogo} mt="3" />;
}
